// import Markdown from "react-markdown";
import React, { FC, ReactElement } from "react";
import styled from "styled-components";
import theme from "theme/theme.main";
import styles from "./styles.module.scss";

interface Props {
  children: ReactElement | ReactElement[];
}

const Container = styled.div`
  font-size: 20px;
  line-height: 1.65;
  font-smooth: antialiased;
  -webkit-font-smoothing: antialiased;

  h1,
  h2,
  h3,
  h4,
  h5 {
    color: ${theme.colors.primaryVariant1};
    font-family: ${theme.fontFamilies.heading};
    line-height: 1.15;
  }
  h1 {
    font-size: 2.44em;
  }
  h2 {
    font-size: 1.95em;
  }
  h3 {
    font-size: 1.56em;
  }
  h4 {
    font-size: 1.25em;
  }
  h5 {
    font-size: 1em;
  }
  p {
    color: ${theme.colors.black};
  }
  a {
    text-decoration: underline;
    font-weight: ${theme.fontWeights.bold};
    color: ${theme.colors.secondaryVariant1};
  }

  @media only screen and (max-width: 1199px) and (min-width: 744px) {
    font-size: 16px;
  }

  @media only screen and (max-width: 743px) {
    font-size: 14px;
  }
`;

const Article: FC<Props> = ({ children }) => {
  return <Container className={styles.container}>{children}</Container>;
};

export default Article;
